import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { clamp } from 'lodash';
import { Debounce } from 'lodash-decorators';
import { UiModule } from '../../../../components/ui.module';
import { LocationService } from '../../../../service/location.service';
import { LocationReviewNotesResponse } from '../../../../types';
import { ReviewManagementBranchLocation } from '../../../../types/usage';
import { ReviewNotesModalComponent } from '../review-notes-modal/review-notes-modal.component';

type CellParams = ICellRendererParams<ReviewManagementBranchLocation> & { disableActions: () => boolean };

@Component({
  selector: 'app-pan-cell-review-management-weekly-reviews',
  imports: [UiModule, FormsModule, ReviewNotesModalComponent],
  templateUrl: './cell-review-management-weekly-reviews.component.html',
  styleUrl: './cell-review-management-weekly-reviews.component.scss',
})
export class CellReviewManagementWeeklyReviewsComponent implements ICellRendererAngularComp {
  private locationService = inject(LocationService);

  public params!: CellParams;

  public cellValue = signal<number>(0);
  public hasNotes = signal(false);
  public showNotes = signal(false);

  agInit(params: CellParams) {
    this.params = params;
    this.cellValue.set(params.data.weekly_reviews ?? 0);
    this.hasNotes.set(!!params.data.has_review_notes);
  }

  onNotesSaved(reviewNotes: LocationReviewNotesResponse) {
    this.hasNotes.set(!!reviewNotes.notes);
    this.params.data.has_review_notes = !!reviewNotes.notes;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }

  changeReviewCount(delta: number) {
    const oldValue = this.cellValue();
    const newValue = clamp(this.cellValue() + delta, 0, 10);
    if (oldValue === newValue) {
      return;
    }

    this.updateReviews(newValue);
  }

  @Debounce(100)
  updateReviews(reviewCount: number) {
    if (!reviewCount || isNaN(reviewCount)) {
      reviewCount = 0;
    }

    this.cellValue.set(reviewCount);

    this.params.data.weekly_reviews = reviewCount;

    this.locationService.updateLocationReviewDemands(+this.params.data.id, { weekly_reviews: reviewCount }).subscribe(() => {});
  }
}
